/**
 * Content PropTypes
 *
 * PropType definitions for CMS content blocks and sections.
 *
 * @module propTypes/content
 */

import PropTypes from "prop-types";

/**
 * Accordion item shape
 * Represents a single collapsible accordion section
 *
 * @property {number} id - Unique identifier info
 * @property {string} title - Accordion section title
 * @property {string} text - Accordion content text, supports markdown
 */
export const accordionItemShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});

/**
 * Content with image shape
 * Represents a content block with text and positioned image
 *
 * @property {string} title - Content block title
 * @property {string} text - Content text, supports markdown
 * @property {string} image - Image URL
 * @property {string} image_position - Image position: "left" or "right"
 */
export const contentWithImageShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  image_position: PropTypes.oneOf(["left", "right"]),
});

/**
 * Hero section shape
 * Represents homepage hero content
 *
 * @property {string} title - Hero title
 * @property {string} subtitle - Hero subtitle
 * @property {string} image - Background image URL
 * @property {string} ctaText - Call-to-action button text
 * @property {string} ctaLink - Call-to-action button link
 */
export const heroSectionShape = PropTypes.shape({
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
});
